module.exports = __webpack_public_path__ + "img/itx-text-strike-through.5ed5c225.svg";